import React, { useState, useEffect } from "react";
import axios from "axios";
import Loading from "../Error Modal/Loading";
import { MDBDataTable } from "mdbreact";
import CloseIcon from "@material-ui/icons/Close";
import No_Image from "../../assets/img/No_Image.png";
import Modal from "react-modal";
import Header from "../Header/Header";
import { useHistory } from "react-router";
import { BaseUrl, BaseUrlFiles } from "../../Constant/Config";
import ErrorModal from "../Error Modal/ErrorModal";
import { Line } from "react-chartjs-2";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import xp from "../../assets/img/xpIco.svg";
import dayli from "../../assets/img/dayIco.svg";
import crown from "../../assets/img/crownIco.svg";
import moment from "jalali-moment";

export default function Profile() {
    const history = useHistory();
    // state
    const [word, setWord] = useState();
    const [userList, setUserList] = useState();
    const [loading, setLoading] = useState(false);
    const [showWord, setShowWord] = useState(false);
    const [type, setType] = useState("");
    const [badge, setBadge] = useState();
    const [badgeData, setBadgeData] = useState();
    const [textError, setTextModal] = useState("");
    const [errorHandler, setErrorHandler] = useState(false);
    const [removeModalIsOpen, setRemoveModalIsOpen] = useState(false);
    const [id, set_id] = useState();

    useEffect(() => {
        const getuserList = () => {
            setLoading(true);
            axios
                .get(
                    `${BaseUrl}/admin/user/${window.location.search.substring(4)}?api_token=${localStorage.getItem("token")}`
                )
                .then((res) => {
                    setUserList(res.data.data);
                    setLoading(false);
                })
                .catch((error) =>
                    error.response.data.status === 401 ? history.push("/login") : null
                );
        };
        getuserList();
    }, []);


    const Options =
    {
        plugins: {
            title: {
                display: false,
                fontSize: 20,
            },
            legend: {
                display: false,
            }
        }
    }

    console.log(userList, "userList")

    if (userList) {
        return (
            <>
                <Header />

                <div class="col-12 container UserProfile">
                    <div class="col-sm-12 col-md-4 col-12 float-right mb-5">
                        <div className="ProfileSidebar text-right">
                            <h3>
                                اطلاعات کاربر
                            </h3>
                            <div className="d-flex align-items-center ">
                                <img src={userList.picture && userList.picture != '' && userList.picture !== null ? BaseUrlFiles + userList.picture : No_Image} />
                                <span>{userList.name}</span>
                            </div>

                            <div className="allInfo">
                                <p>
                                    <strong>شماره موبایل</strong> <span>{userList.phone_number}</span>
                                </p>

                                <p>
                                    <strong>پست الکترونیک</strong> <span>{userList.email}</span>
                                </p>

                                <p>
                                    <strong>تاریخ ثبت نام</strong> <span>{moment(userList.createdAt.substring(0, 10), "YYYY/MM/DD").locale("fa").format("MMMM YYYY")}</span>
                                </p>

                            </div>
                            <h3>نمودار تعداد xp ها در روز</h3>
                            <Line
                                data={{
                                    labels: userList.performance && userList.performance.reverse().slice(0, 7).map((chart, index) => {
                                        var timestamp = chart.date;
                                        var a = new Date(timestamp * 1000);
                                        var days = ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'S'];
                                        var dayOfWeek = days[a.getDay()]
                                        return (dayOfWeek)
                                    }),

                                    datasets: [
                                        {
                                            label: '',
                                            fill: true,
                                            lineTension: 1,
                                            backgroundColor: "transparent",
                                            borderColor: "#f4b8b8",
                                            borderWidth: 2,
                                            data: userList.performance && userList.performance.reverse().slice(0, 7).map((chart) => chart.xp),
                                        },
                                    ],
                                }}
                                options={{
                                    scales: {
                                        y: {

                                            ticks: {
                                                stepSize: 1,
                                                fontSize: 18,
                                                padding: 0,
                                                fontColor: '#000'

                                            }
                                        }

                                    },

                                    title: {
                                        display: true,
                                        font: {
                                            weight: 'bold',
                                            color: '#fff'
                                        },
                                        fontSize: 20,
                                    }, plugins: {
                                        legend: {
                                            display: false,
                                        }


                                    }
                                }}
                            />



                        </div>
                    </div>

                    <div class="col-sm-12 col-md-8 col-12 float-right  ">

                        <div className="row">
                            <div class="col-sm-4 col-md-4 col-12   ">
                                <div className="expUser">
                                    <img src={xp} />
                                    <strong>
                                        تعداد تجربه ها :
                                    </strong>
                                    <span>{userList.xp}</span>
                                </div>

                            </div>

                            <div class="col-sm-4 col-md-4 col-12 ">
                                <div className="expUser">
                                    <img src={crown} />
                                    <strong>
                                        تعداد تاج  :
                                    </strong>
                                    <span>{userList.crown}</span>
                                </div>
                            </div>

                            <div class="col-sm-4 col-md-4 col-12   ">
                                <div className="expUser">
                                    <img src={dayli} />
                                    <strong>
                                        مداومت روزانه :
                                    </strong>
                                    <span>{userList.daily_tracking.length > 0 ? userList.daily_tracking[userList.daily_tracking.length - 1].day_count : 0}</span>
                                </div>
                            </div>


                        </div>


                        <div className="MainContact ">
                            <Tabs>
                                <TabList>
                                    <Tab>کلمات جدید</Tab>
                                    <Tab>کلمات مستقیم</Tab>
                                    <Tab>کلمات غیر مستقیم</Tab>
                                    <Tab>نشان های دریافتی</Tab>
                                </TabList>

                                <TabPanel>
                                    {userList.word_report.new === null || userList.word_report.new.length === 0 ? (
                                        <span className="alert-danger">این کاربر هیچ کلمه جدیدی نیاموخته است</span>
                                    ) : (
                                        userList.word_report.new.map((item, index) => {
                                            return type === "N" ? (
                                                <span className="text_box_user">{item}</span>
                                            ) : (
                                                <div className="text_box_user">
                                                    <div class="badge_style">
                                                        <span className="mt-1">{item.count}</span>
                                                    </div>
                                                    <span>{item}</span>
                                                </div>
                                            );
                                        })
                                    )}
                                </TabPanel>
                                <TabPanel>
                                    {userList.word_report.reviewed_words === null || userList.word_report.reviewed_words.length === 0 ? (
                                        <span className="alert-danger">این کاربر هیچ کلمه مستقیمی نیاموخته است</span>
                                    ) : (
                                        userList.word_report.reviewed_words.map((item, index) => {
                                            return type === "N" ? (
                                                <span className="text_box_user">{item}</span>
                                            ) : (
                                                <div className="text_box_user">
                                                    <div class="badge_style">
                                                        <span className="mt-1">{item.count}</span>
                                                    </div>
                                                    <span>{item.word}</span>
                                                </div>
                                            );
                                        })
                                    )}
                                </TabPanel>
                                <TabPanel>
                                    {userList.word_report.reviewed_indirectly === null || userList.word_report.reviewed_indirectly.length === 0 ? (
                                        <span className="alert-danger">این کاربر هیچ کلمه غیر مستقیمی نیاموخته است</span>
                                    ) : (
                                        userList.word_report.reviewed_indirectly.map((item, index) => {
                                            return type === "N" ? (
                                                <span className="text_box_user">{item}</span>
                                            ) : (
                                                <div className="text_box_user">
                                                    <div class="badge_style">
                                                        <span className="mt-1">{item.count}</span>
                                                    </div>
                                                    <span>{item.word}</span>
                                                </div>
                                            );
                                        })
                                    )}
                                </TabPanel>
                                <TabPanel>
                                    <div className="InfoBadge row">
                                        {
                                            userList.badge.length === 0 ? (
                                                <span className="">این یوزر فاقد نشان است. </span>
                                            ) : (
                                                userList.badge.map((item, index) => {
                                                    let Lastlevel = null;
                                                    let checkLastLevel = item.leveles.findIndex(
                                                        (e) => e.status === false
                                                    );
                                                    const lastlevel = () => {
                                                        if (checkLastLevel < 0) {
                                                            Lastlevel = item.leveles.length - 1;
                                                        } else {
                                                            return (Lastlevel = checkLastLevel);
                                                        }
                                                    };
                                                    lastlevel();

                                                    return (
                                                        <>

                                                            <div className="Data_neshan col-6 col-sm-4 col-md-4">
                                                                <div className="position-relative"  >
                                                                    {
                                                                        item?.id?.picture && item?.id?.picture !== null && item?.id?.picture !== undefined ? (
                                                                            <img style={{ backgroundColor: item?.id?.color }}
                                                                                src={`${BaseUrlFiles}${item?.id?.picture}`}
                                                                                alt="perlingo"
                                                                                className="img_style w-50"
                                                                            />
                                                                        ) :
                                                                            <img style={{ backgroundColor: item?.id?.color }}
                                                                                src={No_Image}
                                                                                alt="perlingo"
                                                                                className="img_style w-50"
                                                                            />

                                                                    }

                                                                    <span className="level_style text_bold">
                                                                        سطح
                                                                        {item?.id?.leveles?.length > 0
                                                                            ? item?.id?.leveles[Lastlevel]?.priority
                                                                            : 1}
                                                                    </span>
                                                                </div>

                                                            </div>

                                                        </>
                                                    );
                                                })
                                            )
                                        }
                                    </div>

                                </TabPanel>
                            </Tabs>
                        </div>
                    </div>
                </div>


                {loading && <Loading isOpen={loading} />}

                {errorHandler ? (
                    <ErrorModal
                        isOpen={errorHandler}
                        error={textError}
                        close={setErrorHandler}
                    />
                ) : null}
            </>
        );
    } else
        return <Loading isOpen={loading} />

}
